module.exports = __webpack_public_path__ + "img/ico-download--black.fd9603de.svg";